import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import {
  Button,
  Card,
  Checkbox,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Grid,
  IconButton,
  Input,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Stack, Breadcrumbs } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import HelpIcon from "@mui/icons-material/HelpOutline";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import FileUploadGroup from "../../../../common/components/FileuploadGroup";
import {createContactList, updateContactList, getContactDetail, getContactList,} from "../actions/contactApi";
import getUserdetailsforsubscrption from "../../dashboard/actions/dashboardaapi";
import { Autocomplete } from "@material-ui/lab";
import { toast } from "react-toastify";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../common/components/Helper/Utils";
import ContentWrapper from "../../../../common/components/contentWrapper";
import { SpinnerRoundFilled } from "spinners-react";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const initialFormState = {
  billingAddress: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zipCode: "",
    country: "United States",
    countryCode: "+1",
  },
  shippingAddress: {
    sameAsBilling: false,
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zipCode: "",
    country: "United States",
    countryCode: "+1",
  },
};

const relationTypeOptions = [
  { id: "supplier", value: "Supplier" },
  { id: "customer", value: "Customer" },
  { id: "partner", value: "Partner" },
  { id: "memo_supplier", value: "Memo Supplier" },
];

const paymentMethods = [
  "Affirm",
  "Cash",
  "Check",
  "Credit Card",
  "Crypto",
  "Paypal",
  "Scrap Gold",
  "Trade",
  "Venmo",
  "Wire",
  "Zelle",
];

const paymentTermsOptions = [
  { id: "Immediate", value: "Immediate" },
  { id: "Net 7 Days", value: "Net 7 Days" },
  { id: "Net 14 Days", value: "Net 14 Days" },
  { id: "Net 21 Days", value: "Net 21 Days" },
  { id: "Net 30 Days", value: "Net 30 Days" },
  { id: "Net 60 Days", value: "Net 60 Days" },
  { id: "Net 90 Days", value: "Net 90 Days" },
];

const AddContactModal = ({ currentContactPage, updateContactPage,
  isEmbedded = false,
  onSuccess,
  onCancel,
  onSavingChange,
}) => {
  const ContentView = () => {
    const history = useHistory();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const relationTypeParam = searchParams.get("type") || null;

    const [isLoading, setLoading] = useState(false);
    const [contactData, setContactData] = useState({});
    const [classificationType, setClassificationType] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [businessName, setBusinessName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneCode, setPhoneCode] = useState("+1");
    const [otherPhoneCode, setOtherPhoneCode] = useState("+1");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [otherPhoneNumber, setOtherPhoneNumber] = useState("");
    const [relationshipType, setRelationshipType] =
      useState(relationTypeOptions);
    const [selectedPaymentMethods, setSelectedPaymentMethods] = useState([]);
    const [paymentTerms, setPaymentTerms] = useState("");
    const [businessCard, setBusinessCard] = useState([]);
    const [businessFileArray, setBusinessFileArray] = useState([]);
    const [EditbusinessFileArray, setEditbusinessFileArray] = useState([]);
    const [EditSalesFileArray, setEditSalesFileArray] = useState([]);
    const [salesTaxID, setSalesTaxID] = useState("");
    const [salesTaxCertificate, setSalesTaxCertificate] = useState([]);
    const [salesFileArray, setSalesFileArray] = useState([]);
    const [invoiceAmount, setInvoiceAmount] = useState(null);
    const [timeStampNotes, setTimeStampNotes] = useState("");
    const [uniqueCountryCode, setUniqueCountryCode] = useState([]);
    const [countryListData, setCountryListData] = useState([]);
    const [statesListData, setStatesListData] = useState([]);
    const [shippingStatesListData, setShippingStatesListData] = useState([]);
    const [formData, setFormData] = useState(initialFormState);
    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState({});
    const [isDirty, setIsDirty] = useState(false);
    const [open, setOpen] = React.useState(false);
    let userData = sessionStorage.getItem("userDetails")
      ? JSON.parse(sessionStorage.getItem("userDetails"))
      : null;
    const accountId = window.sessionStorage.getItem("accountId");
    const isEditPage = window.location.href.includes("edit");
    const disableNameFields = isEditPage && contactData?.isshopify_contact;

    const billingFields = [
      { label: "Address Line 1", field: "addressLine1", type: "input" },
      { label: "Address Line 2", field: "addressLine2", type: "input" },
      { label: "City", field: "city", type: "input" },
      {
        label: "Country",
        field: "country",
        type: "select",
        options: countryListData,
      },
      {
        label: "State",
        field: "state",
        type: "select",
        options: statesListData,
      },
      { label: "Zip Code", field: "zipCode", type: "input" },
    ];

    const shippingFields = [
      { label: "Address Line 1", field: "addressLine1", type: "input" },
      { label: "Address Line 2", field: "addressLine2", type: "input" },
      { label: "City", field: "city", type: "input" },
      {
        label: "Country",
        field: "country",
        type: "select",
        options: countryListData,
      },
      {
        label: "State",
        field: "state",
        type: "select",
        options: shippingStatesListData,
      },
      { label: "Zip Code", field: "zipCode", type: "input" },
    ];

    useEffect(() => {
      if (relationTypeParam) {
        let conversionValue = JSON.parse(atob(relationTypeParam));
        setRelationshipType(conversionValue);
      }
    }, [relationTypeParam]);

    const handleChange = (event, section, field) => {
      const { value, checked, type } = event.target;
      setFormData((prevState) => {
        const fields =
          section === "billingAddress" ? billingFields : shippingFields;

        let updatedSectionData = {
          ...prevState[section],
          [field]: type === "checkbox" ? checked : value,
        };

        setIsDirty(true);

        // Handle country selection separately
        if (field === "country") {
          const selectedCountry = fields
            .find((f) => f.field === "country")
            .options.find((option) => option.name == value);

          updatedSectionData.countryCode = selectedCountry
            ? selectedCountry.phonecode
            : "";
          updatedSectionData.state = "";
        }

        let newState = {
          ...prevState,
          [section]: updatedSectionData,
        };

        // If billing is being updated and "same as billing" is true, update shipping as well
        if (
          section === "billingAddress" &&
          prevState.shippingAddress.sameAsBilling
        ) {
          newState.shippingAddress = {
            ...updatedSectionData,
            sameAsBilling: true,
          };
        }

        // Handle checking/unchecking "same as billing"
        if (section === "shippingAddress" && field === "sameAsBilling") {
          if (checked) {
            // Copy billing address to shipping when "Same as billing" is checked
            return {
              ...prevState,
              shippingAddress: {
                ...prevState.billingAddress,
                sameAsBilling: true,
              },
            };
          } else {
            // Clear shipping address when "Same as billing" is unchecked
            return {
              ...prevState,
              shippingAddress: {
                sameAsBilling: false,
                addressLine1: "",
                addressLine2: "",
                city: "",
                state: "",
                zipCode: "",
                country: "",
                countryCode: "",
              },
            };
          }
        }
        return newState;
      });

      if (
        section === "shippingAddress" &&
        field === "sameAsBilling" &&
        checked &&
        !isEditPage
      ) {
        setShippingStatesListData(statesListData);
      }

      // If country changes, fetch state list
      if (field === "country") {
        const countryObj = countryListData.find((f) => f.name === value);
        getUserdetailsforsubscrption
          .getAllStateList(countryObj?.id)
          .then((res) => {
            if (section === "billingAddress") {
              setStatesListData(res.data.data);
              if (formData.shippingAddress.sameAsBilling) {
                setShippingStatesListData(res.data.data);
              }
            } else if (section === "shippingAddress") {
              setShippingStatesListData(res.data.data);
            }
          });
      }
    };
    const showErrorToast = (message) => {
        toast.error(message || "No Record Found");
    };
    const handleInputChange = (event, setState) => {
      const { value } = event.target;
      setState(value);
      setIsDirty(true);
    };

    const handleBusinessFiles = (value, disablevalue) => {
      const imageFile = disablevalue;
      let fileArray = [];
      for (let i = 0; i < imageFile.length; i++) {
        if (imageFile?.name) {
          fileArray.push(URL.createObjectURL(imageFile[i]));
          continue;
        }
      }
      setBusinessCard(imageFile);
      setBusinessFileArray(fileArray);
      setIsDirty(true);
    };

    const handleSalesFiles = (value, disablevalue) => {
      const imageFile = disablevalue;
      let fileArray = [];
      for (let i = 0; i < imageFile.length; i++) {
        if (imageFile?.name) {
          fileArray.push(URL.createObjectURL(imageFile[i]));
          continue;
        }
      }
      setSalesTaxCertificate(imageFile);
      setSalesFileArray(fileArray);
      setIsDirty(true);
    };

    useEffect(() => {
      getcountryList();
      if (window.location.href.includes("edit")) {
        updateContactPage("CONTACT_EDIT");
      } else {
        updateContactPage("CONTACT_ADD");
      }
    }, []);

    const getcountryList = () => {
      getUserdetailsforsubscrption.getAllCountryList().then((res) => {
        setCountryListData(res?.data?.data);
        let countries = res?.data?.data;
        let countryCode = [];
        countries.filter(({ phonecode }) => countryCode.push(phonecode));
        const UniqueCountryCode = [...new Set(countryCode)];
        setUniqueCountryCode(UniqueCountryCode.sort());
      });

      // Fetch state list for billing and shipping country
      if (
        formData.billingAddress.countryCode &&
        formData.shippingAddress.countryCode
      ) {
        getUserdetailsforsubscrption.getAllStateList(231).then((res) => {
          setStatesListData(res.data.data);
        });
      }

      // // If shipping country code is different from billing, fetch states for shipping country
      // if (formData.shippingAddress.countryCode && formData.billingAddress.countryCode !== formData.shippingAddress.countryCode) {
      //     getUserdetailsforsubscrption
      //         .getAllStateList(formData.shippingAddress.countryCode)
      //         .then((res) => {
      //             setShippingStatesListData(res.data.data);
      //         });
      // }
    };
      useEffect(() => {
      const isEditPage = window.location.href.includes("edit");
      if (!isEditPage) {
        setSelectedPaymentMethods(paymentMethods);
      }
    }, []);

    useEffect(() => {
      if (
        window.location.href.split("/").includes("edit") &&
        countryListData?.length > 0
      ) {
        setLoading(true);
        const id = window.location.href.split("/").pop()
          ? Number(window.location.href.split("/").pop())
          : "";
        getContactDetail(id, (err, response) => {
            setLoading(false);
            if (err) {
                return;
            }
            if (response?.status === 1) {
                if (typeof response.data === "string") {
                    showErrorToast(response.data);
                    return;
                }
                if (Array.isArray(response.data) && response.data.length > 0) {
                    setContactData(response.data[0]);
                }
          }
        });
      }
    }, [countryListData]);

    useEffect(() => {
      fillContactData();
    }, [contactData]);

    const fillContactData = () => {
      if (
        Object.keys(contactData).length > 0 &&
        countryListData &&
        countryListData.length > 0
      ) {
        if (contactData.billingcountrycode) {
          const billCountryCode = countryListData.find(
            (f) => f.name == contactData?.billingcountry
          );
          getUserdetailsforsubscrption
            .getAllStateList(billCountryCode?.id)
            .then((res) => {
              setStatesListData(res.data.data);
            });
        }
        if (contactData.shippingcountrycode) {
          const shipCountryCode = countryListData.find(
            (f) => f.name == contactData?.shippingcountry
          );
          getUserdetailsforsubscrption
            .getAllStateList(shipCountryCode?.id)
            .then((res) => {
              setShippingStatesListData(res.data.data);
            });
        }
        setClassificationType(contactData?.classification_type || "");
        setBusinessName(contactData?.businessname || "");
        setFirstName(contactData?.firstname || "");
        setLastName(contactData?.lastname || "");
        setEmail(contactData?.emailid || "");
        setPhoneCode(contactData?.phonecountrycode || "+1");
        setPhoneNumber(contactData?.phoneno || "");
        setOtherPhoneCode(contactData?.othercountrycode ??(contactData?.otherphone ? "+1" : ""));
        setOtherPhoneNumber(contactData?.otherphone || "");
        setRelationshipType(contactData?.contact_relationtype || []);
        setSalesTaxID(contactData?.sales_taxid || "");
        setInvoiceAmount(contactData?.invoice_amount != null && contactData?.invoice_amount !== ""? Math.round(contactData.invoice_amount): "");
        setTimeStampNotes(contactData?.timestamp_notes || "");
        setSelectedPaymentMethods(contactData?.acceptable_payment || []);
        setPaymentTerms(contactData?.paymentterm || "");
        setBusinessFileArray(contactData?.businesscard_imagepath?.images);
        setEditbusinessFileArray(contactData?.businesscard_imagepath);
        setEditSalesFileArray(contactData?.salestax_imagepath);
        setSalesFileArray(contactData?.salestax_imagepath?.images);

        // Map billing address
        setFormData((prevState) => ({
          ...prevState,
          billingAddress: {
            addressLine1: contactData?.billingaddress1 || "",
            addressLine2: contactData?.billingaddress2 || "",
            city: contactData?.billingcity || "",
            state: contactData?.billingstate?.trim() || "",
            zipCode: contactData?.billingzipcode || "",
            country: contactData?.billingcountry?.trim() || "",
            countryCode: contactData?.billingcountrycode || "",
          },
          // Map shipping address
          shippingAddress: {
            sameAsBilling:
              contactData?.is_same_billing == null
                ? false
                : contactData?.is_same_billing,
            addressLine1: contactData?.shippingaddress1 || "",
            addressLine2: contactData?.shippingaddress2 || "",
            city: contactData?.shippingcity || "",
            state: contactData?.shippingstate?.trim() || "",
            zipCode: contactData?.shippingzipcode || "",
            country: contactData?.shippingcountry?.trim() || "",
            countryCode: contactData?.shippingcountrycode || "",
          },
        }));
      }
    };
    const getSelectValue = (section, fieldName) => {
      const rawVal = formData?.[section]?.[fieldName];
      if (!rawVal && rawVal !== "") return rawVal;

      if (fieldName === "state") {
        const options = section === "billingAddress" ? statesListData : shippingStatesListData;
        if (!options || options.length === 0) return rawVal;

        const match = options.find((opt) => {
          if (!opt || !opt.name) return false;
          return (opt.name || "").toString().trim().toLowerCase() === (rawVal || "").toString().trim().toLowerCase();
        });

        return match ? match.name : rawVal;
      }

      if (fieldName === "country") {
        const options = countryListData;
        if (!options || options.length === 0) return rawVal;

        const match = options.find((opt) => {
          if (!opt || !opt.name) return false;
          return (opt.name || "").toString().trim().toLowerCase() === (rawVal || "").toString().trim().toLowerCase();
        });

        return match ? match.name : rawVal;
      }

      return rawVal;
    };

    // useEffect(() => {
    //     if (formData.shippingAddress.sameAsBilling) {
    //         Copy billing address to shipping when "Same as billing" is checked
    //         setFormData((prevState) => ({
    //             ...prevState,
    //             shippingAddress: {
    //                 ...prevState.billingAddress,
    //                 sameAsBilling: true,
    //             },
    //         }));
    //     }
    //     else {
    //         setFormData((prevState) => ({
    //             ...prevState,
    //             shippingAddress: {
    //                 sameAsBilling: false,
    //                 addressLine1: "",
    //                 addressLine2: "",
    //                 city: "",
    //                 state: "",
    //                 zipCode: "",
    //                 country: "",
    //                 countryCode: "",
    //             },
    //         }));
    //     }
    // }, [formData.shippingAddress.sameAsBilling]);

    const validateInput = () => {
      let error = {};
      let isValid = true;

      if (!classificationType) {
        error["classificationType"] = "Please select any value";
        isValid = false;
      }

      if (
        classificationType === "walk_in" ||
        classificationType === "end_customer"
      ) {
        if (!firstName) {
          error["firstName"] = "Please enter First Name";
          isValid = false;
        }
        if (!lastName) {
          error["lastName"] = "Please enter Last Name";
          isValid = false;
        }
      }

      if (
        classificationType === "end_customer" ||
        classificationType === "business_client"
      ) {
        if (classificationType === "business_client" && !businessName) {
          error["businessName"] = "Please enter Business Name";
          isValid = false;
        }

        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!email && !phoneNumber) {
          error["contactInfo"] = "Please provide either Email or Phone Number";
          isValid = false;
        } else if (email && !emailPattern.test(email)) {
          error["email"] = "Please enter a valid email address";
          isValid = false;
        }
      }

      setError(error);
      return isValid;
    };
    const setSavingState = (saving) => {
      setDisabled(saving);
      if (isEmbedded && onSavingChange) {
        onSavingChange(saving);
      }
    };

    const handleSave = (value) => {
      if (validateInput()) {
        setSavingState(true);
        const shippingStateCode = statesListData.find(item => item.name === formData.shippingAddress.state)?.sortname || '';
        const billingStateCode = statesListData.find(item => item.name === formData.billingAddress.state)?.sortname || '';
        let payload = {
          classification_type: classificationType,
          businessname: businessName,
          firstname: firstName,
          lastname: lastName,
          emailid: email,
          phonecountrycode: phoneCode,
          phoneno: phoneNumber,
          othercountrycode: otherPhoneCode,
          otherphone: otherPhoneNumber,
          sales_taxid: salesTaxID,
          userid: userData?.userId,
          accountid: accountId,
          billingdetails: {
            address1: formData.billingAddress.addressLine1,
            address2: formData.billingAddress.addressLine2,
            city: formData.billingAddress.city,
            state: formData.billingAddress.state,
            statecode: billingStateCode,
            country: formData.billingAddress.country,
            countrycode: formData.billingAddress.countryCode,
            zipcode: formData.billingAddress.zipCode,
          },
          shippingdetails: {
            address1: formData.shippingAddress.addressLine1,
            address2: formData.shippingAddress.addressLine2,
            city: formData.shippingAddress.city,
            state: formData.shippingAddress.state,
            statecode: shippingStateCode,
            country: formData.shippingAddress.country,
            countrycode: formData.shippingAddress.countryCode,
            zipcode: formData.shippingAddress.zipCode,
          },
          relationtype: relationshipType,
          invoice_amount: invoiceAmount,
          timestamp_notes: timeStampNotes,
          acceptable_payment: selectedPaymentMethods,
          preferred_payment: paymentTerms,
          salestax_imagepath: EditSalesFileArray,
          businesscard_imagepath: EditbusinessFileArray,
          is_same_billing:
            formData.shippingAddress.sameAsBilling == null
              ? false
              : formData.shippingAddress.sameAsBilling,
        };

        const hasOtherPhone = !!String(otherPhoneNumber || "").trim();
        if (!hasOtherPhone) {
          payload.otherphone = "";
          payload.othercountrycode =
            value === "edit" ? contactData?.othercountrycode ?? null : null;
        }

        if (classificationType === "walk_in" && value === "edit") {
          payload.invoice_amount =
            contactData?.invoice_amount != null &&
            contactData?.invoice_amount !== ""
              ? contactData.invoice_amount
              : null;
        }
        let formDataType = new FormData();
        for (const key of Object.keys(businessCard)) {
          formDataType.append("businesscard", businessCard[key]);
        }
        for (const key of Object.keys(salesTaxCertificate)) {
          formDataType.append("salescard", salesTaxCertificate[key]);
        }
        for (const key in payload) {
          if (Array.isArray(payload[key])) {
            if (
              payload[key].length > 0 &&
              typeof payload[key][0] === "object"
            ) {
              payload[key].forEach((item, index) => {
                for (const prop in item) {
                  formDataType.append(`${key}[${index}][${prop}]`, item[prop]);
                }
              });
            } else {
              payload[key].forEach((item) => {
                formDataType.append(`${key}[]`, item);
              });
            }
          } else if (
            typeof payload[key] === "object" &&
            payload[key] !== null
          ) {
            for (const nestedKey in payload[key]) {
              formDataType.append(
                `${key}[${nestedKey}]`,
                payload[key][nestedKey]
              );
            }
          } else {
            formDataType.set(key, payload[key]);
          }
        }
        if (value === "save") {
          createContactList(formDataType, (error, response) => {
            if (response && response.status == 1) {
              showSuccessToast(
                response?.message ?? "Contact has been created successfully"
              );
              if (isEmbedded) {
                const notifySuccess = (contact) => {
                  // Keep saving lock until parent closes the dialog
                  if (onSuccess) onSuccess(contact);
                };
                const extractContactId = (res) => {
                  if (!res) return null;
                  const data = res.data;
                  if (typeof data === "number") return data;
                  if (
                    typeof data === "string" &&
                    data.trim() !== "" &&
                    !Number.isNaN(Number(data))
                  ) {
                    return Number(data);
                  }
                  if (Array.isArray(data) && data.length > 0) {
                    return (
                      data[0]?.contactid ??
                      data[0]?.id ??
                      data[0]?.contact_id ??
                      data[0]?.contactId ??
                      null
                    );
                  }
                  if (data && typeof data === "object") {
                    return (
                      data.contactid ??
                      data.id ??
                      data.contact_id ??
                      data.contactId ??
                      null
                    );
                  }
                  return (
                    res.contactid ?? res.id ?? res.contact_id ?? res.contactId ?? null
                  );
                };
                const buildContactFromForm = (id = null) => ({
                  contactid: id || extractContactId(response),
                  classification_type: classificationType,
                  firstname: firstName,
                  lastname: lastName,
                  businessname: businessName,
                  emailid: email,
                  phonecountrycode: phoneCode,
                  phoneno: phoneNumber,
                  acceptable_payment: selectedPaymentMethods,
                  paymentterm: paymentTerms,
                  billingaddress1: formData.billingAddress.addressLine1,
                  billingaddress2: formData.billingAddress.addressLine2,
                  billingcity: formData.billingAddress.city,
                  billingstate: formData.billingAddress.state,
                  billingcountry: formData.billingAddress.country,
                  billingzipcode: formData.billingAddress.zipCode,
                  shippingaddress1: formData.shippingAddress.addressLine1,
                  shippingaddress2: formData.shippingAddress.addressLine2,
                  shippingcity: formData.shippingAddress.city,
                  shippingstate: formData.shippingAddress.state,
                  shippingcountry: formData.shippingAddress.country,
                  shippingzipcode: formData.shippingAddress.zipCode,
                });
                const resolveCreatedContact = (contactId) => {
                  if (contactId) {
                    getContactDetail(contactId, (err, detailRes) => {
                      if (
                        !err &&
                        detailRes?.status === 1 &&
                        Array.isArray(detailRes.data) &&
                        detailRes.data.length > 0
                      ) {
                        notifySuccess({
                          ...detailRes.data[0],
                          acceptable_payment:
                            detailRes.data[0]?.acceptable_payment?.length > 0
                              ? detailRes.data[0].acceptable_payment
                              : selectedPaymentMethods,
                          paymentterm:
                            detailRes.data[0]?.paymentterm || paymentTerms,
                        });
                      } else {
                        notifySuccess(buildContactFromForm(contactId));
                      }
                    });
                    return;
                  }

                  const searchKey =
                    (email && email.trim()) ||
                    `${firstName || ""} ${lastName || ""}`.trim() ||
                    (businessName && businessName.trim()) ||
                    "";
                  if (!searchKey) {
                    notifySuccess(buildContactFromForm());
                    return;
                  }

                  getContactList(
                    {
                      accountid: accountId,
                      emailsearch: searchKey,
                      classification: classificationType
                        ? [classificationType]
                        : [],
                      status: false,
                    },
                    20,
                    1,
                    (listErr, listRes) => {
                      if (
                        !listErr &&
                        listRes?.status == 1 &&
                        Array.isArray(listRes.data) &&
                        listRes.data.length > 0
                      ) {
                        const matched =
                          listRes.data.find((c) => {
                            if (email && c?.emailid) {
                              return (
                                String(c.emailid).toLowerCase() ===
                                String(email).toLowerCase()
                              );
                            }
                            if (phoneNumber && c?.phoneno) {
                              return (
                                String(c.phoneno).replace(/\W+/g, "") ===
                                String(phoneNumber).replace(/\W+/g, "")
                              );
                            }
                            return false;
                          }) || listRes.data[0];
                        notifySuccess({
                          ...matched,
                          acceptable_payment:
                            matched?.acceptable_payment?.length > 0
                              ? matched.acceptable_payment
                              : selectedPaymentMethods,
                          paymentterm: matched?.paymentterm || paymentTerms,
                        });
                      } else {
                        notifySuccess(buildContactFromForm());
                      }
                    }
                  );
                };

                const contactFromResponse =
                  response?.data &&
                  typeof response.data === "object" &&
                  !Array.isArray(response.data) &&
                  (response.data.contactid ||
                    response.data.firstname ||
                    response.data.emailid)
                    ? response.data
                    : Array.isArray(response?.data) &&
                      response.data[0] &&
                      typeof response.data[0] === "object"
                    ? response.data[0]
                    : null;

                if (contactFromResponse?.contactid || contactFromResponse?.id) {
                  const id =
                    contactFromResponse.contactid || contactFromResponse.id;
                  if (
                    contactFromResponse.firstname ||
                    contactFromResponse.emailid ||
                    contactFromResponse.businessname
                  ) {
                    notifySuccess({
                      ...buildContactFromForm(id),
                      ...contactFromResponse,
                      contactid: id,
                      acceptable_payment:
                        contactFromResponse?.acceptable_payment?.length > 0
                          ? contactFromResponse.acceptable_payment
                          : selectedPaymentMethods,
                      paymentterm:
                        contactFromResponse?.paymentterm || paymentTerms,
                    });
                  } else {
                    resolveCreatedContact(id);
                  }
                } else {
                  resolveCreatedContact(extractContactId(response));
                }
              } else {
                setSavingState(false);
              updateContactPage("CONTACT_HOME");
              history.push("/contactmanagement");
              }
            } else if (response) {
              setSavingState(false);
              showErrorToast(
                response?.message ? response?.message : "Something went wrong"
              );
            } else if (error) {
              setSavingState(false);
              showErrorToast(error);
            }
          });
        } else if (value === "edit") {
          formDataType.set("contactid", contactData?.contactid);
          updateContactList(formDataType, (error, response) => {
            if (response && response.status == 1) {
              setSavingState(false);
              showSuccessToast(
                response?.message ?? "Contact has been updated successfully"
              );
              updateContactPage("CONTACT_HOME");
              history.push("/contactmanagement");
            } else if (response) {
              setSavingState(false);
              showErrorToast(response?.message ?? "Something went wrong");
            } else if (error) {
              setSavingState(false);
              showErrorToast(error);
            }
          });
        }
      } else {
        if (isEmbedded) {
          const dialogContent = document.querySelector(
            ".create-contact-dialog-content"
          );
          if (dialogContent) {
            dialogContent.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }
    };

    const handleRedirect = () => {
      if (disabled) return;
      if (isEmbedded && onCancel) {
        onCancel();
        return;
      }
      updateContactPage("CONTACT_HOME");
      history.push("/contactmanagement");
    };

    const renderFormFields = (fields, section) => {
      return fields.map((field, index) => (
        <Grid item xs={12} key={index}>
          <FormControl variant="standard" className="formControl">
            <InputLabel
              htmlFor={`${section}-${field.field}`}
              style={{ color: "#424242" }}
            >
              {field.label}
            </InputLabel>
            {field.type === "input" ? (
              <Input
                id={`${section}-${field.field}`}
                value={formData[section][field.field]}
                onChange={(event) => handleChange(event, section, field.field)}
                style={{ marginBottom: "8px" }}
                disabled={
                  section === "shippingAddress" &&
                  formData.shippingAddress.sameAsBilling
                }
                inputProps={{
                  maxLength: field.field === "zipCode" ? 10 : 120,
                  autoComplete: "off",
                }}
              // onKeyPress={(event) => {
              //     if (field.field === "zipCode" && !/^\d+$/.test(event.key)) {
              //         event.preventDefault();
              //     }
              // }}
              />
            ) : (
              <Select
                id={`${section}-${field.field}`}
                value={getSelectValue(section, field.field)}
                onChange={(event) => handleChange(event, section, field.field)}
                style={{ marginBottom: "8px" }}
                disabled={
                  section === "shippingAddress" &&
                  formData.shippingAddress.sameAsBilling
                }
              >
                <MenuItem value="">Select</MenuItem>
                {/* {field.label == 'State' ?
                                    field.options.map((option, idx) => {
                                        return (
                                            <MenuItem key={idx} value={option.sortname}>
                                                {option.name}
                                            </MenuItem>
                                        );
                                    })
                                    :  */}
                {field.options.map((option, idx) => {
                  return (
                    <MenuItem key={idx} value={option.name}>
                      {option.name}
                    </MenuItem>
                  );
                })}
                {/* {field.options.map((option, idx) => {
                                    if (option?.phonecode) {
                                        return (
                                            <MenuItem key={idx} value={option.phonecode}>
                                                {option.name}
                                            </MenuItem>
                                        );
                                    }
                                    else {
                                        return (
                                            <MenuItem key={idx} value={option.sortname}>
                                                {option.name}
                                            </MenuItem>
                                        );
                                    }

                                })} */}
              </Select>
            )}
          </FormControl>
        </Grid>
      ));
    };

    const handleAutoComplete = (event, newValue) => {
      setRelationshipType(newValue);
      setIsDirty(true);
    };

    const handleClose = (event, reason) => {
      if (reason === "blur" || reason === "escape") {
        setOpen(false);
      }
    };

    const getOptionSelected = (option, value) => option.id === value.id;

    const handlePaymentMethodChange = (event) => {
      const { value } = event.target;
      setSelectedPaymentMethods((prev) =>
        prev?.includes(value)
          ? prev.filter((method) => method !== value)
          : [...prev, value]
      );
      setIsDirty(true);
    };

    return (
      <div className={
          isEmbedded
            ? ""
            : "space-bottom-30 someextrahight extra-space-10"}>
        <Container
          maxWidth={isEmbedded ? false : "lg"}
          disableGutters={isEmbedded}
        >
          {!isEmbedded && (
          <Stack spacing={1}>
            <Breadcrumbs
              aria-label="breadcrumb"
              separator={<span className="sperator">›</span>}
            >
              <Link
                style={{
                  fontSize: "14px",
                  color: "#CEA05F",
                  textDecoration: "underline !important",
                }}
                onClick={() => handleRedirect()}
              >
                Contact Management
              </Link>
              <Grid
                style={{
                  fontSize: "14px",
                  color: "#9e9e9e",
                  backgroundColor: "white",
                }}
                aria-current="page"
              >
                {window.location.href.split("/").includes("edit")
                  ? "Edit Contact"
                  : "Add Contact"}
              </Grid>
            </Breadcrumbs>
          </Stack>
          )}
          {isLoading ? (
            <div className="d-spinner">
              <SpinnerRoundFilled
                size={51}
                thickness={125}
                speed={80}
                color="rgba(57, 107, 172, 1)"
                className="spp"
                enabled={isLoading}
              />
            </div>
          ) : (
            <Card className={isEmbedded ? "d-pt" : "padding-20 d-pt"}
              elevation={isEmbedded ? 0 : 1}
              style={isEmbedded ? { boxShadow: "none" } : undefined}
            >
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12} className="space-bottom">
                      <Typography variant="h6">
                        Contact Classification
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} className="space-bottom">
                      <FormControl variant="standard" className="formControl">
                        <InputLabel
                          htmlFor="component-simple"
                          style={{ color: "#424242" }}
                        >
                          Type <span style={{ color: "red" }}> * </span>
                        </InputLabel>
                        <Select
                          id="component-simple"
                          value={classificationType}
                          onChange={(e) =>
                            handleInputChange(e, setClassificationType)
                          }
                        >
                          {!isEmbedded && (<MenuItem value="walk_in">Walk-In / Temporary Customers</MenuItem>)}
                          <MenuItem value="business_client">
                            Business Contact
                          </MenuItem>
                          <MenuItem value="end_customer">
                            {" "}
                            Retail Contact{" "}
                          </MenuItem>
                        </Select>
                        <FormHelperText className="error-o">
                          {error["classificationType"]}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                  className="space-marign-top-10 space-bottom"
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography variant="h6">General Information</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="standard" className="formControl">
                        <InputLabel
                          htmlFor="component-simple"
                          style={{ color: "#424242" }}
                        >
                          First Name
                          {classificationType !== "business_client" && (
                            <span style={{ color: "red" }}> * </span>
                          )}
                        </InputLabel>
                        <Input
                          id="component-simple"
                          style={{ marginBottom: "8px" }}
                          value={firstName}
                          onChange={(e) => handleInputChange(e, setFirstName)}
                          disabled={disableNameFields}
                          inputProps={{
                            maxLength: 50,
                            autoComplete: "off",
                          }}
                        />
                        <FormHelperText className="error-o">
                          {error["firstName"]}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="standard" className="formControl">
                        <InputLabel
                          htmlFor="component-simple"
                          style={{ color: "#424242" }}
                        >
                          Last Name
                          {classificationType !== "business_client" && (
                            <span style={{ color: "red" }}> * </span>
                          )}
                        </InputLabel>
                        <Input
                          id="component-simple"
                          style={{ marginBottom: "8px" }}
                          value={lastName}
                          onChange={(e) => handleInputChange(e, setLastName)}
                          disabled={disableNameFields}
                          inputProps={{
                            maxLength: 50,
                            autoComplete: "off",
                          }}
                        />
                        <FormHelperText className="error-o">
                          {error["lastName"]}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="standard" className="formControl">
                        <InputLabel
                          htmlFor="component-simple"
                          style={{ color: "#424242" }}
                        >
                          Business Name
                          {classificationType === "business_client" && (
                            <span style={{ color: "red" }}> * </span>
                          )}
                        </InputLabel>
                        <Input
                          id="component-simple"
                          style={{ marginBottom: "8px" }}
                          value={businessName}
                          onChange={(e) =>
                            handleInputChange(e, setBusinessName)
                          }
                          inputProps={{
                            maxLength: 150,
                            autoComplete: "off",
                          }}
                        />
                        <FormHelperText className="error-o">
                          {error["businessName"]}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="standard" className="formControl">
                        <InputLabel
                          htmlFor="component-simple"
                          style={{ color: "#424242" }}
                        >
                          Email
                          {classificationType !== "walk_in" && (
                            <span style={{ color: "red" }}> * </span>
                          )}
                        </InputLabel>
                        <Input
                          id="component-simple"
                          style={{ marginBottom: "8px" }}
                          value={email}
                          onChange={(e) => handleInputChange(e, setEmail)}
                        />
                        <FormHelperText className="error-o">
                          {error["contactInfo"] ?? error["email"]}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={2} style={{ textAlign: "center" }}>
                      <FormControl variant="standard" className="formControl">
                        <InputLabel
                          htmlFor="component-simple"
                          style={{ color: "#424242" }}
                        ></InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={phoneCode}
                          onChange={(e) => handleInputChange(e, setPhoneCode)}
                        >
                          {uniqueCountryCode &&
                            uniqueCountryCode.map((country) => (
                              <MenuItem key={country} value={country}>
                                {`${country}`}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={10}>
                      <FormControl variant="standard" className="formControl">
                        <InputLabel
                          htmlFor="component-simple"
                          style={{ color: "#424242" }}
                        >
                          Phone Number
                          {classificationType !== "walk_in" && (
                            <span style={{ color: "red" }}> * </span>
                          )}
                        </InputLabel>
                        <Input
                          id="component-simple"
                          style={{ marginBottom: "8px" }}
                          value={phoneNumber}
                          onChange={(e) => handleInputChange(e, setPhoneNumber)}
                          inputProps={{
                            maxLength: 14,
                            autoComplete: "off",
                          }}
                          onKeyPress={(event) => {
                            if (!/^\d+$/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <FormHelperText className="error-o">
                          <FormHelperText className="error-o"></FormHelperText>
                          {error["contactInfo"]}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={2} style={{ textAlign: "center" }}>
                      <FormControl variant="standard" className="formControl">
                        <InputLabel
                          htmlFor="component-simple"
                          style={{ color: "#424242" }}
                        ></InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={otherPhoneCode}
                          onChange={(e) =>
                            handleInputChange(e, setOtherPhoneCode)
                          }
                        >
                          {uniqueCountryCode &&
                            uniqueCountryCode.map((country) => (
                              <MenuItem key={country} value={country}>
                                {`${country}`}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={10}>
                      <FormControl variant="standard" className="formControl">
                        <InputLabel
                          htmlFor="component-simple"
                          style={{ color: "#424242" }}
                        >
                          Other Phone Number
                        </InputLabel>
                        <Input
                          id="component-simple"
                          style={{ marginBottom: "8px" }}
                          value={otherPhoneNumber}
                          onChange={(e) =>
                            handleInputChange(e, setOtherPhoneNumber)
                          }
                          inputProps={{
                            maxLength: 14,
                            autoComplete: "off",
                          }}
                          onKeyPress={(event) => {
                            if (!/^\d+$/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                      </FormControl>
                    </Grid>
                    {/* <Grid item xs={12}>
                                <FormControl variant="standard" className="formControl">
                                    <InputLabel
                                        htmlFor="component-simple"
                                        style={{ color: "#424242" }}
                                    >
                                        Contact Relationship Type
                                    </InputLabel>
                                    <Select
                                        id="component-simple"
                                        value={relationshipType}
                                        onChange={(e) => handleInputChange(e, setRelationshipType)}
                                    >
                                        <MenuItem value="supplier">Supplier</MenuItem>
                                        <MenuItem value="customer">Customer</MenuItem>
                                        <MenuItem value="partner"> Partner </MenuItem>
                                        <MenuItem value="memo_supplier"> Memo Supplier </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid> */}
                    <Grid item xs={12}>
                      <FormControl variant="standard" className="formControl">
                        <Autocomplete
                          multiple
                          name="relationshipType"
                          limitTags={2}
                          options={relationTypeOptions}
                          disableCloseOnSelect
                          open={open}
                          onOpen={() => setOpen(true)}
                          onClose={handleClose}
                          renderOption={(option, { selected }) => (
                            <React.Fragment>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                checked={selected}
                              />
                              {option.value}
                            </React.Fragment>
                          )}
                          getOptionLabel={(option) => option.value}
                          getOptionSelected={getOptionSelected}
                          value={relationshipType}
                          onChange={handleAutoComplete}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              label="Relationship Type"
                              InputLabelProps={{
                                className:
                                  "MuiFormControlLabel-root contact-add-field",
                              }}
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                    {/* {relationshipType?.some(
                      (type) => type.value === "Customer"
                    ) && (
                        <> */}
                          <Grid item xs={12} className="space-marign-top-10">
                            <FormControl
                              variant="standard"
                              className="formControl"
                            >
                              <FormLabel
                                component="label"
                                htmlFor="component-simple"
                                style={{ color: "#424242" }}
                              >
                                Acceptable Payment Methods
                              </FormLabel>
                              <FormGroup row>
                                {paymentMethods.map((method) => (
                                  <FormControlLabel
                                    key={method}
                                    control={
                                      <Checkbox
                                        value={method}
                                        checked={selectedPaymentMethods?.includes(
                                          method
                                        )}
                                        onChange={handlePaymentMethodChange}
                                      />
                                    }
                                    label={method}
                                  />
                                ))}
                              </FormGroup>
                            </FormControl>
                          </Grid>
                           {relationshipType?.some(
                            (type) => type.value === "Customer"
                          ) && (
                            <>
                          <Grid
                            item
                            xs={12}
                            className="space-marign-top-10 space-bottom"
                          >
                            <FormControl
                              variant="standard"
                              className="formControl"
                            >
                              <InputLabel
                                htmlFor="component-simple"
                                style={{ color: "#424242" }}
                              >
                                Preferred Payment Terms
                              </InputLabel>
                              <Select
                                id="component-simple"
                                value={paymentTerms}
                                onChange={(e) =>
                                  handleInputChange(e, setPaymentTerms)
                                }
                              >
                                {paymentTermsOptions.map((option, idx) => {
                                  return (
                                    <MenuItem key={idx} value={option.id}>
                                      {option.value}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Grid>
                        </>
                      )}
                    <Grid item xs={12}>
                      <InputLabel
                        htmlFor="component-simple"
                        style={{
                          color: "#424242",
                          marginBottom: "20px",
                          float: "left",
                          marginTop: "20px",
                        }}
                      >
                        Image Upload for ID or Business Card&nbsp;
                      </InputLabel>
                      {/* <Tooltip
                                    title="Please attach images separately as high resolution JPG/PNG/JPEG/GIF/PDF/DOC"
                                    style={{ position: "relative", top: 3, cursor: "pointer" }}
                                >
                                    <HelpIcon
                                        fontSize="10px"
                                        style={{ color: "#CEA05F", marginTop: "14px" }}
                                    />
                                </Tooltip> */}
                      {currentContactPage === "contactEditPage" ? (
                        <FileUploadGroup
                          imageDetails={businessFileArray}
                          page={"Edit"}
                          onFilesChange={handleBusinessFiles}
                          id={"BusinessCard"}
                        />
                      ) : (
                        <FileUploadGroup
                          onFilesChange={handleBusinessFiles}
                          id={"BusinessCard"}
                        />
                      )}
                    </Grid>
                    {/* {classificationType === "business_client" && ( */}
                    <>
                      <Grid item xs={12}>
                        <FormControl variant="standard" className="formControl">
                          <InputLabel
                            htmlFor="component-simple"
                            style={{ color: "#424242" }}
                          >
                            Sales Tax ID
                          </InputLabel>
                          <Input
                            id="component-simple"
                            style={{ marginBottom: "8px" }}
                            value={salesTaxID}
                            onChange={(e) =>
                              handleInputChange(e, setSalesTaxID)
                            }
                            inputProps={{
                              type: "phone",
                              maxLength: 14,
                              autoComplete: "off",
                            }}
                            onKeyPress={(event) => {
                              if (!/^[a-zA-Z0-9]+$/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <InputLabel
                          htmlFor="component-simple"
                          style={{
                            color: "#424242",
                            marginBottom: "20px",
                            float: "left",
                            marginTop: "20px",
                          }}
                        >
                          Upload Sales Tax Certificate Image (or PDF)&nbsp;
                        </InputLabel>
                        {/* <Tooltip
                                            title="Please attach images separately as high resolution JPG/PNG/JPEG/GIF/PDF/DOC"
                                            style={{
                                                position: "relative",
                                                top: 3,
                                                cursor: "pointer",
                                            }}
                                        >
                                            <HelpIcon
                                                fontSize="10px"
                                                style={{ color: "#CEA05F", marginTop: "14px" }}
                                            />
                                        </Tooltip> */}
                        {currentContactPage === "contactEditPage" ? (
                          <FileUploadGroup
                            imageDetails={salesFileArray}
                            page={"Edit"}
                            onFilesChange={handleSalesFiles}
                            id={"SalesTaxCertificate"}
                          />
                        ) : (
                          <FileUploadGroup
                            onFilesChange={handleSalesFiles}
                            id={"SalesTaxCertificate"}
                          />
                        )}
                      </Grid>
                    </>
                    {/* )} */}
                    {classificationType && classificationType !== "walk_in" && (
                      <Grid item xs={12}>
                        <FormControl variant="standard" className="formControl">
                          <InputLabel
                            htmlFor="component-simple"
                            style={{ color: "#424242" }}
                          >
                            Total Allowed Open Invoices Amount
                          </InputLabel>
                          <Input
                            id="component-simple"
                            style={{ marginBottom: "8px" }}
                            value={invoiceAmount || ""}
                            inputProps={{
                              inputMode: "decimal",
                              autoComplete: "off",
                            }}
                            onChange={(e) => {
                              let value = e.target.value.replace(/[^0-9.]/g, "");
                              const parts = value.split(".");
                              if (parts.length > 2) {
                                value = parts[0] + "." + parts.slice(1).join("");
                              }
                              setInvoiceAmount(value);
                              setIsDirty(true);
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9.]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </FormControl>
                      </Grid>
                    )}
                    <Grid item xs={12}>
                      <FormControl variant="standard" className="formControl">
                        <InputLabel
                          htmlFor="component-simple"
                          style={{ color: "#424242" }}
                        >
                          Notes
                        </InputLabel>
                        <Input
                          id="component-simple"
                          style={{ marginBottom: "8px" }}
                          value={timeStampNotes}
                          onChange={(e) =>
                            handleInputChange(e, setTimeStampNotes)
                          }
                          multiline
                          maxRows={4}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                  className="space-marign-top-10 space-bottom"
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography variant="h6" style={{ marginBottom: "7px" }}>
                        Billing Address
                      </Typography>
                      <Grid container spacing={1}>
                        {renderFormFields(billingFields, "billingAddress")}
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h6">Shipping Address</Typography>
                      <Grid container spacing={1}>
                        <Grid item xs={12} justifyContent="flex-end">
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="sameAsBilling"
                                checked={formData.shippingAddress.sameAsBilling}
                                onChange={(event) =>
                                  handleChange(
                                    event,
                                    "shippingAddress",
                                    "sameAsBilling"
                                  )
                                }
                              />
                            }
                            label="Same as billing address"
                          />
                        </Grid>
                        {renderFormFields(shippingFields, "shippingAddress")}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "20px",
                  }}
                >
                  <Button
                    type="button"
                    className="SubmitColor space-marign-20"
                    onClick={handleRedirect}
                    disabled={disabled}
                    style={{
                      cursor: disabled ? "not-allowed" : "pointer",
                      opacity: disabled ? 0.5 : 1,
                    }}
                  >
                    Cancel
                  </Button>
                  {currentContactPage === "contactEditPage" ? (
                    <Button
                      type="submit"
                      className="SubmitColor space-marign-20"
                      onClick={(e) => {
                        if (disabled) {
                        e.preventDefault();
                        e.stopPropagation();
                        return;
                        }
                      handleSave("edit");
                      }}
                      disableElevation
                        disabled={disabled}
                      style={{
                       cursor: disabled ? "not-allowed" : "pointer",
                       opacity: disabled ? 0.5 : 1,
                      }}
                    >
                      Update
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      className="SubmitColor space-marign-20"
                      onClick={() => handleSave("save")}
                      disabled={disabled}
                      style={{
                        cursor: disabled ? "not-allowed" : "pointer",
                        opacity: disabled ? 0.5 : 1,
                      }}
                    >
                      {disabled && isEmbedded ? "Saving..." : "Save"}
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Card>
          )}
        </Container>
      </div>
    );
  };
  return isEmbedded ? ( ContentView()) : (<ContentWrapper contentView={ContentView()} />);
};

const mapStateToProps = ({ ContactManagement }) => {
  return {
    currentContactPage: ContactManagement.contactManagement,
    // contactViewData: ContactManagement.contactViewData,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateContactPage: (type) => ({ type: type }),
      updateContactData: (payload) => ({ type: "CONTACT_VIEW_DATA", payload }),
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AddContactModal);
